var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhoneBook1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.14254 19.8571V4.14286C4.14254 2.4071 5.54964 1 7.28539 1H19.8568C21.5926 1 22.9997 2.4071 22.9997 4.14286V19.8571M4.14254 19.8571C4.14254 21.5929 5.54964 23 7.28539 23H19.8568C21.5926 23 22.9997 21.5929 22.9997 19.8571M4.14254 19.8571C9.73401 15.6792 17.4082 15.6792 22.9997 19.8571M1 7.28642H4.14286M1 12.0004H4.14286M1 16.7145H4.14286M16.7142 8.85689C16.7142 10.5926 15.3071 11.9997 13.5714 11.9997C11.8356 11.9997 10.4285 10.5926 10.4285 8.85689C10.4285 7.12113 11.8356 5.71403 13.5714 5.71403C15.3071 5.71403 16.7142 7.12113 16.7142 8.85689Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneBook1);
export default __webpack_public_path__ + "static/media/phone_book1.cfad66707e395c745af38173cb52d8d7.svg";
export { ForwardRef as ReactComponent };